<template>
  <div>
    <!--    <v-btn @click="$i18n.locale = 'ru'">ru</v-btn>-->
    <!--    <v-btn @click="$i18n.locale = 'en'">en</v-btn>-->
    <popup2 :value="!!event" @input="event = null" width="428">
      <edit-field
        v-if="event === 'addGroup'"
        :type="'chips'"
        :title="'Add log to groups'"
        :field="'Groups'"
        :value="[]"
      />
      <component
        v-else-if="event"
        :entity="{}"
        :is="event"
        @update-table="updateTable"
        @close="event = null"
      />
    </popup2>
    <table-page
      :toolbar="toolbar"
      :entity="true"
      :table="table"
      @event="eventHandler"
    />
  </div>
</template>

<script>
import pageActions from './pageActions';
import selectedActions from './selectedActions';
import {
  ref,
  computed,
  onMounted,
  reactive,
  toRefs
} from '@vue/composition-api';
import useNoty from '@/api/notifications';
import convertDate from '@/utils/convertDate';
import toSnakeCase from 'lodash.snakecase';
import { nanoid } from 'nanoid';
import dateTypesService from '@/services/datatypes';
import useAuth from '@/api/auth';
import cloneDeep from "lodash.clonedeep";
export default {
  name: 'datatypes',
  metaInfo: {
    titleTemplate: '%s | Data Types'
  },
  components: {
    addNew: () => import('./edit')
  },
  setup(props, context) {
    const event = ref(null);

    const { profile } = useAuth();
    const toolbar = ref({
      title: 'Data types',
      pageActions,
      selectedActions
    });

    const columns = computed(() => {
      if (state.connection[0]) {
        let t = [];
        state.visibleFields.forEach(item => {
          t.push({
            key: item,
            value: item,
            text: context.root.$t(`propertyType.${item}`)
          });
        });
        return t;
      }
      return [];
    });

    const computeIcon = i => {
      switch (i.tags) {
        case 'alert':
          return 'mdi-bell-ring';
        case 'notice':
          return 'mdi-volume-high';
        default:
          return 'mdi-message-text';
      }
    };

    const items = computed(() =>
      state.connection.map(i => ({
        ...i,
        iconFallback: 'mdi-form-textbox'
      }))
    );
    const setParams = data => {
      if (data === null) {
        state.params = {};
      } else {
        state.params = { ...state.params, ...data };
      }
    };
    const state = reactive({
      connection: [],
      visibleFields: ['name', 'description'],
      params: {
        filter: null,
        first: 10,
        offset: 0,
        orderBy: 'NATURAL'
      },
      table: {
        filters: [],
        total: 0,
        items,
        columns,
        settings: ['name', 'description'],
        loading: false,
        itemRoute: 'datatypesTableComponent'
      }
    });
    function eventHandler({ event: e, data }) {
      switch (e) {
        case 'setSettings': {
          // visibleFields.value = data;
          break;
        }
        case 'addNew': {
          event.value = 'addNew';
          break;
        }
        case 'addGroup': {
          event.value = 'addGroup';
          break;
        }
        case 'setFilters': {
          state.table.filters = cloneDeep(data);

          setParams({ offset: 0 });
          let filter = {};
          data
            .filter(i => {
              if (Array.isArray(i.model) && i.model.length > 0) {
                return true;
              } else if (!Array.isArray(i.model) && i.model.value !== null) {
                return true;
              }
              return false;
            })
            .forEach(i => {
              filter = {
                ...filter,
                ...i?.getFilter()
              };
            });

          load(filter);
          break;
        }
        case 'filteringTable': {
          const result = {};
          if (data.perPage) {
            result.first = data.perPage;
          }
          result.offset = (data.page - 1) * state.params.first; // : 0;
          if (data.desc) {
            setParams({ desc: data.desc.length ? data.desc[0] : false });
          }
          if (data.sort) {
            if (data.sort.length) {
              setParams({ sort: data.sort[0] });
            } else {
              setParams({ sort: null });
              setParams({ orderBy: 'NATURAL' });
            }
          }
          if (data.desc && state.params.sort) {
            result.orderBy = toSnakeCase(state.params.sort).toUpperCase();
            result.orderBy += `_${state.params.desc ? 'DESC' : 'ASC'}`;
          } else if (state.params.orderBy) {
            result.orderBy = state.params.orderBy;
          }
          setParams({
            orderBy: result.orderBy,
            first: result.first || state.params.first,
            offset: result.offset
          });
          if (!data.sort) {
            load(state.params.filter);
          }
          break;
        }
      }
    }

    function saveHandler() {
      switch (event.value) {
        case 'addNew':
          break;
      }
    }
    function updateTable(id) {
      load();
    }

    async function load() {
      dateTypesService.load(state.params).then(res => {
        state.connection = res.data.propertyTypesConnection.edges.map(
          item => item.node
        );
      });
    }

    onMounted(async () => {
      setParams({
        orderBy: 'CREATED_AT_DESC',
        first:
          profile.value?.objectProperties.find(
            item => item.key === 'programNumbersOfRows'
          )?.value || 20
      });
      await load();
      state.table.filters = [
        {
          id: 'subject',
          title: 'Subject',
          getFilter() {
            return {
              enabled: {
                equalTo: this.model.value
              }
            };
          },
          model: {
            name: 'All',
            value: null
          },
          values: [
            { name: 'Device', id: nanoid(), value: null },
            { name: 'Media', id: nanoid(), value: true },
            { name: 'Dataset', id: nanoid(), value: false },
            { name: 'Application', id: nanoid(), value: false },
            { name: 'No subject', id: nanoid(), value: false }
          ]
        },
        {
          id: 'tags',
          title: 'Tags',
          getFilter() {
            return {
              tags: {
                contains: this.model
              }
            };
          },
          type: 'tags-live',
          values: ['alert', 'notice', 'message', 'admin', 'direct message']
        },
        {
          id: 'From',
          title: 'From',
          getFilter() {
            return {
              tags: {
                contains: this.model
              }
            };
          },
          type: 'date',
          values: null
        },
        {
          id: 'From',
          title: 'From',
          getFilter() {
            return {
              tags: {
                contains: this.model
              }
            };
          },
          type: 'date',
          values: null
        }
      ];
    });
    return {
      ...toRefs(state),
      event,
      toolbar,
      saveHandler,
      eventHandler,
      updateTable
    };
  }
};
</script>
